var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m9.737 1.553 3.661 4a.663.663 0 0 1 .175.447v7a1.695 1.695 0 0 1-1.723 1.666H4.528A1.695 1.695 0 0 1 2.804 13V3a1.695 1.695 0 0 1 1.723-1.667h4.71c.19 0 .372.08.499.22zm1.642 3.78-1.844-2v1.443c-.018.29.205.54.498.557h1.346zm.471 8H4.528a.355.355 0 0 1-.377-.332V3a.355.355 0 0 1 .375-.334h3.662v2.1a1.868 1.868 0 0 0 1.825 1.9h2.214V13a.355.355 0 0 1-.376.333h-.001zm-5.68-4h2.019a.67.67 0 0 0 .673-.667A.67.67 0 0 0 8.189 8h-2.02a.67.67 0 0 0-.672.666.67.67 0 0 0 .673.667zm0 1.333a.67.67 0 0 0-.673.667.67.67 0 0 0 .673.667h4.038a.67.67 0 0 0 .673-.667.67.67 0 0 0-.673-.667H6.17z",
    fill: "#1E90FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.7888a8fad61c642172c27fa3616b05d3.svg";
export { ForwardRef as ReactComponent };